module.exports = __webpack_public_path__ + "img/US_MeleeDPS_ua.b765070a.webp";